import { DeleteOutlined, WarningOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import AppTag from 'common/components/tag.component';
import { CatalogTranscription } from 'config/constants/transcription.constant';
import { AppTagColor } from 'config/utils/catalog.util';
import React from 'react';
import styles from './style.module.scss';

type ProductNoStockProps = {
  withButton?: boolean;
  onDeleteProductFromCart?: () => void;
};

const ProductNoStock: React.FC<ProductNoStockProps> = ({ withButton = false, onDeleteProductFromCart }) => {
  return (
    <React.Fragment>
      <div className={styles['product-no-stock-container']}>
        <AppTag text={CatalogTranscription.OUT_OF_STOCK_VARIANT} color={AppTagColor.WARNING} contentIcon={<WarningOutlined />} />
        {withButton && onDeleteProductFromCart && (
          <Button type='link' block icon={<DeleteOutlined />} onClick={() => onDeleteProductFromCart()}>
            {CatalogTranscription.DELETE_PRODUCT_FROM_CART}
          </Button>
        )}
      </div>
    </React.Fragment>
  );
};

export default ProductNoStock;
